// @flow
import { identify } from './identify'
import { identifyOrReset } from './identify_or_reset'
import page from './page'
import reset from './reset'
import track from './track'
import prospect from './prospect'

export default {
  identify,
  identifyOrReset,
  page,
  reset,
  track,
  prospect,
}
